import React, { useState } from 'react'
import { string, array, func, node } from 'prop-types'
import styled, { css } from 'styled-components'
import { stripUnit } from 'polished'

// import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Icon from 'components/Icon'
import { H4, fontWeights } from 'styles/typography'
import { square } from 'styles/global'
import * as spacing from 'styles/spacing'
import { borderColor, green } from 'styles/colors'
// import { Product } from 'components/buy/Addon'
// import EngravingAddon from 'components/buy/EngravingAddon'

import DownChevron from 'icons/down-chevron.svg'

const Container = styled.div`
  position: relative;

  & + & {
    border-top: 1px solid ${borderColor};
  }
`

const Heading = styled(H4)`
  flex: 1;
  padding-right: ${spacing.large};
  margin: 0;
`

const IconWrap = styled.span`
  display: flex;
  flex-shrink: 0;
  ${square('24px')};

  ${props =>
    props.flipped &&
    css`
      transform: rotate(180deg);
    `}
`

const Trigger = styled.button`
  width: 100%;
  padding: ${stripUnit(spacing.medium) * 1.25 + 'px'} ${spacing.large};
  text-align: left;
`

const Main = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

// const Cart = styled.div`
//   padding: ${spacing.large};
//   padding-top: 0;
// `

const Content = styled.div`
  padding: ${spacing.large};
  padding-top: 0;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  cursor: pointer;
  z-index: 1;
`

const Added = styled.span`
  color: ${green};
  margin-left: auto;
  margin-right: ${spacing.medium};
  font-weight: ${fontWeights.bold};
`

const MobileOption = ({ heading, children, onAdd, products }) => {
  // const { collection, dispatch } = useContext(BuyFlowContext)
  // const { engraving } = useContext(EngravingContext)
  const [expanded, setExpanded] = useState(false)

  return (
    <Container>
      {onAdd && <Overlay onClick={onAdd} />}
      <Trigger
        onClick={() => {
          setExpanded(!expanded)
        }}
      >
        <Main>
          <Heading>{heading}</Heading>
          {products && products.length > 0 && <Added>Added</Added>}
          <IconWrap flipped={expanded}>
            <Icon icon={<DownChevron />} />
          </IconWrap>
        </Main>
      </Trigger>
      {/* {products && products.length > 0 && (
        <>
          <Cart>
            {products.map((p, i) => {
              const productIndex = collection[productType].edges.findIndex(skin => skin.node.id === p.node.id)
              let quantity = 0

              if (collection[productType]) {
                collection[productType].edges[productIndex].node.variants.edges.forEach(variant => {
                  quantity += variant.node.quantity
                })
              }

              return (
                <Product
                  name={p.node.title}
                  figure={p.node.variants.edges[0].node.image.originalSrc}
                  quantity={quantity}
                  isSkin={productType === 'skins'}
                  isEngraving={isEngraving}
                  onRemove={() => {
                    collection[productType].edges[productIndex].node.variants.edges.forEach((variant, j) => {
                      collection[productType].edges[productIndex].node.variants.edges[j].node.quantity = 0
                    })
                    dispatch({ type: 'set collection', collection })
                  }}
                />
              )
            })}
          </Cart>
        </>
      )}
      {isEngraving && engraving.proceeded && (
        <Cart>
          <EngravingAddon />
        </Cart>
      )} */}
      {expanded && <Content>{children}</Content>}
    </Container>
  )
}

MobileOption.propTypes = {
  heading: string,
  products: array,
  onAdd: func,
  children: node
}

export default MobileOption
